import { Rect } from "js/core/utilities/geom";

/**
 * Calculate bounding box for single or multiple DOM elements
 * @param target - CSS selector string or array of selectors
 * @param padding - Optional padding to add around the bounding box (default: 0)
 * @returns Bounding box object with top, left, width, height, or null if no elements found
 */
export function calculateBoundingBox(
    target: string | string[],
    padding: number = 0
): { top: number; left: number; width: number; height: number } | null {
    const selectors = Array.isArray(target) ? target : [target];
    const elements: HTMLElement[] = [];

    selectors.forEach(selector => {
        const matches = document.querySelectorAll(selector);
        matches.forEach(el => {
            if (el instanceof HTMLElement) {
                elements.push(el);
            }
        });
    });

    if (elements.length === 0) {
        return null;
    }

    // Convert first element's bounding rect to Rect
    let unionRect = Rect.FromBoundingClientRect(elements[0].getBoundingClientRect());

    // Union with remaining elements
    for (let i = 1; i < elements.length; i++) {
        const elementRect = Rect.FromBoundingClientRect(elements[i].getBoundingClientRect());
        unionRect = unionRect.union(elementRect);
    }

    // Add padding if specified
    if (padding > 0) {
        unionRect = unionRect.inflate(padding);
    }

    return unionRect.toObject();
}

